import clsx from 'clsx';
import { FC } from 'react';
import { IconSVG } from 'atoms/IconSVG';
import { Link } from 'atoms/Link/Link';
import { Info } from 'atoms/Typography/Typography';
import { gtmPushShopNavigation } from 'modules/gtm/modules/sections/navigation/navigation';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useMediaQuery } from 'modules/mui/hooks';
import { useCart } from 'modules/shop/cart/hooks';
import { usePopoverManager } from 'modules/shop/popoverManager/hooks';
import { PopoverType } from 'modules/shop/popoverManager/types';
import { AppRoutes } from 'modules/shop/routes';
import styles from './header-icon.module.css';

export const CartIcon: FC<{
  onClick?: () => void;
  className?: string;
  color?: 'black' | 'white';
}> = ({ onClick, className, color = 'black' }) => {
  const t = useTranslations();
  const { cart } = useCart();
  const { openPopover } = usePopoverManager();
  const count = cart?.items?.length;

  const { isSmallDesktop } = useMediaQuery();

  const handleClick = () => {
    onClick?.();
    openPopover(PopoverType.CART);
    gtmPushShopNavigation(t('header.gtmNavigationLabels.cartIcon'));
  };

  if (isSmallDesktop) {
    return (
      <div className={styles.icon} onClick={handleClick}>
        {!!count && (
          <Info className={clsx(styles.counter, styles[color])}>{count}</Info>
        )}
        <IconSVG
          type="cart"
          className={clsx(styles.invertIcon, className, styles[color])}
        />
      </div>
    );
  }

  return (
    <Link href={AppRoutes.CART} className={styles.icon}>
      <Info className={clsx(styles.counter, styles[color])}>{count}</Info>
      <IconSVG
        type="cart"
        className={clsx(styles.invertIcon, className, styles[color])}
      />
    </Link>
  );
};
